import { FileType } from '@office-start/document-types';
import { Referral } from '@office-start/telemetry-types';
import { getReferral } from '@office-start/telemetry-utility';
import { getFileTypeNameFromType } from './getFileTypeNameFromType';
export function getOtelReferralFromFileType(fileType) {
    switch (fileType) {
        case FileType.Word:
            return Referral.WordOnline;
        case FileType.Excel:
            return Referral.ExcelOnline;
        case FileType.PowerPoint:
            return Referral.PowerPointOnline;
        case FileType.OneNote:
            return Referral.OneNoteOnline;
        case FileType.Sway:
            return Referral.Sway;
        case FileType.Visio:
            return Referral.VisioOnline;
        case FileType.Project:
        case FileType.ProjectOperations:
        case FileType.Portfolio:
            return Referral.Project;
        case FileType.PowerBI:
            return Referral.PowerBI;
        default:
            return getReferral(getFileTypeNameFromType(fileType));
    }
}
//# sourceMappingURL=getOtelReferralFromFileType.js.map